exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".detail-row td[data-v-211aea3c]{height:60px}", "", {"version":3,"sources":["/app/src/components/master/onboarding/ProviderCandidate.vue"],"names":[],"mappings":"AACA,gCACE,WAAa,CACd","file":"ProviderCandidate.vue","sourcesContent":["\n.detail-row td[data-v-211aea3c] {\n  height: 60px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-211aea3c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/onboarding/ProviderCandidate.vue
// module id = 848
// module chunks = 26